import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from './common/SafeIcon';
import { FiInbox, FiUsers, FiBook, FiAlertTriangle, FiPieChart, FiSettings, FiHexagon, FiPlayCircle } from 'react-icons/fi';
import { cn } from '../lib/utils';

const navItems = [
  { id: 'inbox', icon: FiInbox, label: 'Inbox', badge: 3 },
  { id: 'escalations', icon: FiAlertTriangle, label: 'Escalations', badge: 1 },
  { id: 'analytics', icon: FiPieChart, label: 'Analytics' },
  { id: 'demo', icon: FiPlayCircle, label: 'Demo', glow: true },
  { id: 'customers', icon: FiUsers, label: 'Customers' },
  { id: 'knowledge', icon: FiBook, label: 'Knowledge Base' },
  { id: 'settings', icon: FiSettings, label: 'Settings' },
];

export default function Sidebar({ activeTab, setActiveTab }) {
  return (
    <div className="w-16 lg:w-64 h-screen border-r border-navy-700 bg-navy-800 flex flex-col transition-all duration-300 shrink-0">
      <div className="h-16 flex items-center justify-center lg:justify-start lg:px-6 border-b border-navy-700">
        <SafeIcon icon={FiHexagon} className="text-cyan-neon text-2xl" />
        <span className="hidden lg:block ml-3 font-semibold text-lg text-white tracking-wide">SupportNova</span>
      </div>

      <nav className="flex-1 py-6 flex flex-col gap-2 px-3 overflow-y-auto scrollbar-hide">
        {navItems.map((item) => (
          <button
            key={item.id}
            onClick={() => setActiveTab(item.id)}
            className={cn(
              "relative flex items-center justify-center lg:justify-start p-3 rounded-xl transition-all duration-200 group min-h-[48px]",
              activeTab === item.id 
                ? "bg-navy-700 text-cyan-neon" 
                : "text-slate-400 hover:bg-navy-700/50 hover:text-white",
              item.glow && "border border-cyan-neon/20 shadow-[0_0_10px_rgba(0,240,255,0.1)]"
            )}
          >
            {activeTab === item.id && (
              <motion.div
                layoutId="activeTabIndicator"
                className="absolute left-0 w-1 h-8 bg-cyan-neon rounded-r-full"
                initial={false}
              />
            )}
            <SafeIcon icon={item.icon} className={cn("text-xl", item.glow && activeTab !== item.id && "text-cyan-neon/70")} />
            <span className="hidden lg:block ml-3 font-medium">{item.label}</span>
            {item.badge && (
              <span className={cn(
                "absolute top-1 right-1 lg:static lg:ml-auto text-[10px] lg:text-xs font-bold px-1.5 py-0.5 rounded-full",
                item.id === 'escalations' ? "bg-priority-red/20 text-priority-red" : "bg-cyan-neon/20 text-cyan-neon"
              )}>
                {item.badge}
              </span>
            )}
          </button>
        ))}
      </nav>

      <div className="p-4 border-t border-navy-700 hidden lg:flex items-center gap-3">
        <img src="https://images.unsplash.com/photo-1568602471122-7832951cc4c5?w=100&h=100&fit=crop" alt="Agent" className="w-8 h-8 rounded-full border border-navy-600" />
        <div className="flex flex-col">
          <span className="text-sm text-white font-medium">Agent 04</span>
          <span className="text-xs text-green-400 flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-green-400"></span> Online
          </span>
        </div>
      </div>
    </div>
  );
}